import { createQueryParams } from '@/utils/query-params';
import { api } from './index';

// The registros clínicos whose history the office opens
// (ClinicalRecordHistory::ITEM_TYPES).
export type ClinicalRecordItemType =
  | 'ReportText'
  | 'VitalSignRecord'
  | 'MedicalRecord'
  | 'TaskRecord'
  | 'Note'
  | 'PatientDocument'
  | 'Patient'
  | 'MedicationOrder';

export interface ClinicalRecordChange {
  field: string;
  label: string;
  oldValue: string | null;
  newValue: string | null;
}

// One write to the registro, or to a part of it (`part`: "Presión arterial",
// "Pausa"). `create` is the write that recorded it, `void` the one that anuló it.
export interface ClinicalRecordVersion {
  id: number;
  event: 'create' | 'update' | 'void' | 'destroy';
  part: string | null;
  createdAt: string;
  author: string;
  changes: ClinicalRecordChange[];
}

export const clinicalRecordHistoryApi = {
  show(itemType: ClinicalRecordItemType, itemId: number): Promise<ClinicalRecordVersion[]> {
    return api({
      method: 'get',
      url: `/api/internal/clinical_record_history?${createQueryParams({ itemType, itemId })}`,
    }).then(response => response.data.versions);
  },
};
